import React from "react";
import himansu from "../../Assets/Artist/Himanshu Trivedi 24-09-25.png";
import dimple from "../../Assets/Artist/Dimple Pancholi 26-09-25.png";
import payalabhijit from "../../Assets/Artist/Payal Vakharia & Abhijit Rao 28-09-25.png";
import jasraj from "../../Assets/Artist/jayraj shastri  new.jpg";
import madhavioza from "../../Assets/Artist/Madhavi Oza 23-09-25.png";
import mayurisoni from "../../Assets/Artist/Mayuri Soni 22-09-25.png";
import mihir from "../../Assets/Artist/Mihir Jani 29-09-25.png";
import samirraval from "../../Assets/Artist/Samir Raval 25-09-25.png";
import yashbarot from "../../Assets/Artist/Yash Barot 01-10-25.png";
import nainasharma from "../../Assets/Artist/Naina Sharma 27-09-25.png";
import KausikOutdoors from "../../Assets/kausikOutdoors.jpg";
import MyFm from "../../Assets/RadioPartner.jpg";
import Bookmyshow from "../../Assets/BookMyShow.jpg";

interface EventDetails {
  date: string;
  artist: string;
  artistImage: string;
}

const events: EventDetails[] = [
  { date: "22 Sep", artist: "Mayuri Soni", artistImage: mayurisoni },
  { date: "23 Sep", artist: "Madhavi Oza", artistImage: madhavioza },
  { date: "24 sep", artist: "Himanshu Trivedi Rao", artistImage: himansu },
  { date: "25 Sep", artist: "Samir Raval", artistImage: samirraval },
  { date: "26 Sep", artist: "Dimple Pancholi", artistImage: dimple },
  { date: "27 Sep", artist: "Naina Sharma",artistImage: nainasharma,},
  {date: "28 Sep", artist: "Payal Vakhariya & Abhijit Rao",artistImage: payalabhijit, },
  { date: "29 Sep", artist: "Mihir Jani", artistImage: mihir },
  { date: "30 Sep", artist: "Jasraj Shastri", artistImage: jasraj },
  {date: "01 Oct", artist: "Yash Barot",artistImage: yashbarot,},
];

const Orchesta: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      {/* Header Image */}
      <div className="p-4 bg-gradient-to-b from-blue-900 to-teal-400 text-white mb-1 rounded-lg shadow-md">
        <h1 className="text-sm md:text-2xl font-bold text-center">
          Orchesta List for 22 Sep to 01 Oct, 2025
        </h1>
      </div>

      {/* Artist Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 gap-6 mt-4">
        {events.map((event, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <div className="w-10 h-10 sm:w-25 sm:h-30 md:w-25 md:h-30 lg:w-25 lg:h-30 bg-gray-200 rounded-full overflow-hidden shadow-md">
              <img
                src={event.artistImage}
                alt={event.artist}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="mt-4 text-sm font-semibold">{event.artist}</h3>
            <p className="text-sm text-gray-500">{event.date}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3  gap-6 mt-4">
        <div className="flex flex-col justify-center items-center text-center shadow-md p-4 rounded-lg">
          <img
            src={KausikOutdoors}
            alt="Outdoors Partner"
            className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain mb-2"
          />
          <h3 className="text-sm font-semibold">Outdoors Partner</h3>
        </div>
        <div className="flex flex-col justify-center items-center text-center shadow-md p-4 rounded-lg">
          <img
            src={MyFm}
            alt="Radio Partner"
            className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain mb-2"
          />
          <h3 className="text-sm font-semibold">Radio Partner</h3>
        </div>
        <div className="flex flex-col justify-center items-center text-center shadow-md p-4 rounded-lg">
          <img
            src={Bookmyshow}
            alt="Online Ticket Available"
            className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain mb-2"
          />
          <h3 className="text-sm font-semibold">Online Ticket Available</h3>
        </div>
      </div>
    </div>
  );
};

export default Orchesta;
